var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE6123",
    d: "M37.5 10c-6.9 0-12.5 5.6-12.5 12.5v55c0 6.9 5.6 12.5 12.5 12.5h25c6.9 0 12.5-5.6 12.5-12.5V47.5c0-6.9-5.6-12.5-12.5-12.5H50v-12.5C50 15.6 44.4 10 37.5 10zm0 10c1.4 0 2.5 1.1 2.5 2.5v22.5h-15V22.5c0-1.4 1.1-2.5 2.5-2.5h10zm0 35h12.5c1.4 0 2.5 1.1 2.5 2.5v20c0 1.4-1.1 2.5-2.5 2.5h-12.5c-1.4 0-2.5-1.1-2.5-2.5v-20c0-1.4 1.1-2.5 2.5-2.5zm25 0c1.4 0 2.5 1.1 2.5 2.5v20c0 1.4-1.1 2.5-2.5 2.5H55V55h7.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitly);
export default __webpack_public_path__ + "static/media/bitly.3f80111d58da4226f94f404a8605d302.svg";
export { ForwardRef as ReactComponent };